import React, { useState } from "react";
import { CRMDeferPopout } from "../../CrmDeferPopout/CRMDeferPopout";
import { CRMIcon } from "../../CRMIcon/CRMIcon";

type TCRMJobDeferCellProps = {
    onDefer: (deferredDate: string) => void;
};

export const CRMJobDeferCell = (props: TCRMJobDeferCellProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
    };

    const defer = (deferredDate: string | null) => {
        if (deferredDate === null) {
            return;
        }
        props.onDefer(deferredDate);
        setIsOpen(false);
    };

    return (
        <div className="crm-job-defer-cell">
            <div
                className="crm-job-defer-cell__chip"
                onClick={toggle}
                title="Set defer date"
            >
                <CRMIcon
                    iconName="snooze"
                    colour="neutral-ink"
                    size="small"
                />
            </div>

            {isOpen &&
                <div
                    className="crm-job-defer-cell__popout"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                >
                    <CRMDeferPopout
                        options="all"
                        onChange={defer}
                    />
                </div>
            }
        </div>
    );
};
